import {
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  MenuItem,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import LabeledDropDown from "../TemplateProperties/TPDropDown";
import { useDispatch, useSelector } from "react-redux";
import { api } from "../../redux/api";
import ArrowRightIcon from "@mui/icons-material/ArrowRight";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import KeyboardDoubleArrowDownIcon from '@mui/icons-material/KeyboardDoubleArrowDown';
import KeyboardDoubleArrowUpIcon from '@mui/icons-material/KeyboardDoubleArrowUp';
import { eachDeep } from "deepdash-es/standalone";
import LightTooltip from '../../commonComponents/LightTooltip';
import Tree from "rc-tree";
import { workflowGroupsToRcTree } from "../../utils/rctreeDataConversion";
import WorkflowSessionModal2 from "./WorkflowSessionModal2";

const WorkflowSessionModal1 = ({ openModal, handleClose ,valueHandler, sourceType, showSelection, previousValue, selection, handleTextFieldClick, inputType, specialPasswordField, initialMaskLength}) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [accounts, setAccounts] = useState([]);
  const [accountList,setAccountsList] = useState([]);
  const [account, setAccount] = useState("");
  const [selectedKeys, setSelectedKeys] = useState([]);
  const [expandedKeys, setExpandedKeys] = useState([]);
  const [openModal2,setOpenModal2] = useState(false);
  const [workflowLoading, setWorkflowLoading] = useState(false);
  const [selectedTemplate, setSelectedTemplate] = useState({
    account: "",
    template: "",
    workflow: "",
  });
  const [actions, setActions] = useState({
    back: false,
    next: false,
    finish: false,
  });
  const queryParams = useSelector((state) => state.queryParams);
  const [treeData, setTreeData] = useState([]);

  const accountHandler = (e) => {
    const { value } = e.target;
    setAccount(value);
    setSelectedKeys([]);
    setExpandedKeys([]);
    setActions(prev=>{return {back: false,next: false,finish: false,}});
    setSelectedTemplate({template:'',workflow:'',account:''})
  };

  //RC-Tree Functions

  const iconRender = (node) => {
    return (
      <span
        className={node.type === "workflowGroup" ? "RECORD" : "CALL_WORKFLOW"}
      ></span>
    );
  };

  const switcherIcon = (obj) => {
    if (obj.isLeaf) return;
    if (obj.expanded) return <ArrowDropDownIcon />;
    else return <ArrowRightIcon sx={{ color: "#666666" }} />;
  };

  const onExpand = (expandedKeys) => {
    setExpandedKeys(expandedKeys);
  };

  const onSelect = (selectedKeys, info) => {
    setSelectedKeys([info.node.key]);
    if(info.node.type !== 'workflowGroup'){
      setActions(prev=>{return {...prev,next:true}});
      setSelectedTemplate({
        template:info.node.title,
        workflow:info.node.workflowGroup,
        account:account
      })
    }else {
      setActions(prev=>{return {back: false,next: false,finish: false,}});
      setSelectedTemplate({template:'',workflow:'',account:''})
    }
  };

  const getAllParentNode = (translatedData) => {
    const parentNodes = [];
    eachDeep(translatedData, (obj) => {
      if (obj?.key && obj?.children?.length) {
        parentNodes.push(obj.key);
      }
    });
    return parentNodes;
  };

  const handleExpand = () => {
    const parentNodeArray = getAllParentNode(treeData);
    setExpandedKeys(parentNodeArray);
  };

  const handleCollapse = () => {
    setExpandedKeys([]);
  };

  const resetStates =()=>{
    setActions(prev=>{return {back: false,next: false,finish: false,}});
    setSelectedTemplate({template:'',workflow:'',account:''})
    setSelectedKeys([]);
    setExpandedKeys([]);
    getAccounts();
  }

  const handleClose2 = (value, isOpenParentModal) => {
    setOpenModal2(value);
    handleClose(false, isOpenParentModal)
  }

  const getAccounts = ()=>{
    dispatch(api.endpoints.getAccounts.initiate()).then((res) => {
      if(res?.data?.current_state === "SUCCESS") {
        const accountList = res?.data?.data?.accounts || [];
        const selectedAccount = accountList.find(ele=>ele === queryParams?.account);
        const menuItems =
          accountList?.map((e, i) => {
            return (
              <MenuItem key={i} value={e}>
                {e}
              </MenuItem>
            );
          }) || [];
        setAccounts(menuItems);
        setAccount(accountList?.length ? selectedAccount ? selectedAccount : accountList[0] : "");
      }
    });
  }

  useEffect(() => {
    getAccounts();
  }, []);

  

  useEffect(() => {
    setTreeData([]);
    if (account) {
      setWorkflowLoading(true);
      dispatch(
        api.endpoints.getWorkflows.initiate({ account }, { forceRefetch: true })
      ).then((res) => {
        if(res?.data?.current_state === "SUCCESS") {
          const workflows = res?.data?.data || [];
          const tree = workflowGroupsToRcTree(workflows, "workflow");
          setTreeData(tree);
        }
      })
      .finally(() => {
        setWorkflowLoading(false);
      })
    }
  }, [account]);

  return (
    <>
      <Dialog
        open={openModal}
        fullWidth
        maxWidth="sm"
        sx={{ overflow: "hidden" }}
      >
        <DialogTitle className="dialog-header">
          <div className="title">
            {" "}
            {t("DIAG_WORKFLOW_SESSION_VARIABLE_WIZARD")}{" "}
          </div>
          <div style={{fontSize:'15px',fontWeight:'500'}}>
            {" "}
            {t("DIAG_WORKFLOW_SESSION_VARIABLE_WIZARD1_TIT")}{" "}
          </div>
          <div className="description">
            {" "}
            {t("DIAG_WORKFLOW_SESSION_VARIABLE_WIZARD1_DESC")}{" "}
          </div>
        </DialogTitle>
        <DialogContent
          sx={{ overflow: "auto", width: "100%", padding: "0 !important" }}
          className="modal-content"
          dividers
        >
          <Box padding={"20px"}>
            <LabeledDropDown
              label={t("ACCOUNT")}
              options={accounts}
              onChange={accountHandler}
              value={
                accounts?.filter((e) => e?.props?.value === account)?.length
                  ? account
                  : ""
              }
              style={{marginBottom: "10px"}}
            />

            <Box sx={{ display: 'flex', gap: '4px', marginBottom: '10px', justifyContent: 'flex-end' }}>
              <LightTooltip title={t('BTN_EXPAND_ALL_ITEMS')}>
                <span>
                  <IconButton
                    variant="outlined"
                    onClick={handleExpand}
                    size="small"
                    disabled={!treeData?.length || workflowLoading}
                  >
                    <KeyboardDoubleArrowDownIcon fontSize="small" />
                  </IconButton>
                </span>
              </LightTooltip>
              <LightTooltip title={t('BTN_COLLAPSE_ALL_ITEMS')}>
                <span>
                  <IconButton
                    variant="outlined"
                    onClick={handleCollapse}
                    size="small"
                    disabled={!treeData?.length || workflowLoading}
                  >
                    <KeyboardDoubleArrowUpIcon fontSize="small" />
                  </IconButton>
                </span>
              </LightTooltip>
            </Box>

            <Box
              sx={{
                height: "40vh",
                overflowX: "hidden",
                maxHeight: "400px",
                border: "2px solid rgba(0, 0, 0, 0.12)",
                borderRadius: "0.2rem",
                display: workflowLoading ? "flex" : "block",
                justifyContent: "center",
                alignItems: "center"
              }}
            >
              {workflowLoading ? <CircularProgress/> : treeData?.length ?
              <Tree
                treeData={treeData}
                selectedKeys={selectedKeys}
                onSelect={onSelect}
                onExpand={onExpand}
                expandedKeys={expandedKeys}
                icon={iconRender}
                switcherIcon={switcherIcon}
              /> : <div className="panel-no-data"> {t("FRG_NO_WKFLOS_FOUND_FOR_ACNT").slice(0, -1)} </div> }
            </Box>
          </Box>
        </DialogContent>
        <DialogActions>
          {sourceType === "callingWorkflow" && <Button
            size="small"
            variant="outlined"
            color="primary"
            onClick={() =>{
              handleClose(false, true);
            }}
          >
            {" "}
            {t("BTN_BACK")}
          </Button>}
          <Button
            size="small"
            disabled={!actions.next}
            variant="outlined"
            color="primary"
            onClick={() =>{
              handleClose(false);
               setOpenModal2(true)
            }}
          >
            {" "}
            {t("BTN_NEXT")}
          </Button>
          <Button
            size="small"
            variant="outlined"
            color="primary"
            onClick={() => {
              handleClose(false, true);
              resetStates();
            }}
          >
            {" "}
            {t("BTN_CANCEL")}
          </Button>
        </DialogActions>
      </Dialog>
      <WorkflowSessionModal2
        inputType={inputType}
        handleTextFieldClick={handleTextFieldClick}
        previousValue={previousValue}
        showSelection={showSelection}
        sourceType={sourceType}
        openModal={openModal2}
        handleClose2={handleClose2}
        handleClose1={handleClose}
        resetStates={resetStates}
        selectedTemplate={selectedTemplate}
        valueHandler={valueHandler}
        selection={selection}
        specialPasswordField={specialPasswordField}
        initialMaskLength={initialMaskLength}
      />
    </>
  );
};

export default WorkflowSessionModal1;
